import React, { useEffect, useState } from "react"
import { Col, Form, Row } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import {
  antdesignSelectStyle,
  getType,
  toastStyle,
} from "../../../Helpers/Utils/Common"
import { searchHistory } from "../../../Helpers/apiCalls/Inventory/ItemListApi"
import { numberFormat } from "../../../Helpers/Utils/Common"
import { getAllItems, searchItem } from "../../../Helpers/apiCalls/itemsApi"
import Select from "react-select"
import { Select as SearchBox } from "antd"
import { getAllBranches } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import { searchOrder } from "./../../../Helpers/apiCalls/Reports/DailyOrdersApi"
import toast, { Toaster } from "react-hot-toast"
//components
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/NoSortTable"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import DatePicker from "react-datepicker"
import Smoothie from "../../../Assets/Images/Report/smoothie.png"
import ViewModal from "../../../Components/Modals/ViewModal"
import Moment from "moment"
import * as XLSX from "xlsx"

//css
import "./../Inventory.css"
import "../../../Components/Navbar/Navbar.css"
import Footer from "../../../Components/Footer/Footer"

export default function ItemHistory() {
  const { branch_id, item_id, item_unit_id, unit } = useParams()

  let item_unit = unit
  let source_api = ""
  if (unit.includes("-")) {
    item_unit = unit.split("-")[0]
    source_api = unit.split("-")[1]
  }

  let navigate = useNavigate()
  const [isChanged, setIsChanged] = useState(false)
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [itemList, setItemList] = useState([])
  const [branchName, setBranchName] = useState("")
  const [branches, setBranches] = useState([])
  const [itemNames, setItemNames] = useState([])
  const [excelData, setExcelData] = useState([])
  const [itemUnit, setItemUnit] = useState("")
  const [itemNamesValue, setItemNamesValue] = useState({
    name: "item_id",
    label: "",
    value: item_id,
  })
  const [branchValue, setBranchValue] = useState({
    name: "branch",
    label: "",
    value: "",
  })

  const xlsxHeaders = [
    "Date",
    "DOC Type",
    "Slip No.",
    "In",
    "Out",
    "Current Qty",
    "Branch From",
    "Branch To",
    "Encoded On",
    "Transfer Date",
    "Receive Date",
    "Added By",
  ]

  const excelHeaders = [
    { label: "Date", key: "date" },
    { label: "DOC Type", key: "doc_type" },
    { label: "Slip No.", key: "slip_no" },
    { label: "In", key: "in" },
    { label: "Out", key: "out" },
    { label: "Current Qty", key: "current_qty" },
    { label: "Branch From", key: "branch_from_name" },
    { label: "Branch To", key: "branch_to_name" },
    { label: "Encoded On", key: "encoded_on" },
    { label: "Transfer Date", key: "transfer_date" },
    { label: "Receive Date", key: "receive_date" },
    { label: "Added By", key: "added_by_name" },
  ]

  const date = new Date()
  date.setDate(date.getDate() - 7)
  const nextDay = new Date()
  nextDay.setDate(nextDay.getDate() + 1)

  /* FILTER CONFIGS */
  const [filterConfig, setFilterConfig] = useState({
    branch_id: branch_id,
    item_id: item_id,
    date_from: date,
    date_to: nextDay,
  })

  const [selectedRow, setSelectedRow] = useState([])

  // VIEW ORDER MODAL
  const [showViewModal, setShowViewModal] = useState(false)
  const handleShowViewModal = () => setShowViewModal(true)
  const handleCloseViewModal = () => setShowViewModal(false)

  const handleAddChange = (e, type) => {
    setIsChanged(!isChanged)
    setItemList([])

    if (type === "item") {
      const selectedValue = e ? e.value : null
      if (selectedValue) {
        var item_name = itemNames.filter((data) => {
          return data.value === selectedValue
        })

        if (item_name.length > 0) {
          setItemNamesValue({
            label: item_name[0].label,
            value: item_name[0].value,
          })
          if (item_name[0].unit) {
            setItemUnit(item_name[0].unit)
          } else {
            setItemUnit("")
          }
          setFilterConfig((prev) => ({ ...prev, item_id: item_name[0].value }))
        }
      }
    } else if (type === "branch") {
      setBranchValue({
        name: e.name,
        label: e.label,
        value: e.value,
        type: e.type,
      })
      setFilterConfig((prev) => {
        return { ...prev, [e.name]: e.value }
      })
    } else {
      const { name, value } = e.target
      setFilterConfig((prev) => {
        return { ...prev, [name]: value }
      })
    }
  }

  const handleSearchItem = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      handleFetchItems(newValue, setItemNames)
    }
  }

  // new api for searching items
  async function handleFetchItems(value, setItemNames) {
    setItemNames([])
    const response = await searchItem({ name: value, branch_id: branch_id })
    if (response.response) {
      var itemsList = response.response.data.map((data) => {
        var info = data
        info.label = `${data.name}-${data.item_units[0]?.unit_from}`
        info.value = data.id
        info.unit = data.unit_from_name

        return info
      })
      setItemNames(itemsList)
    } else {
      return toast.error(response.error?.data?.messages.message, {
        style: toastStyle(),
      })
    }
  }

  async function fetchAllItems() {
    const response = await getAllItems(branch_id)

    if (response.response.data) {
      var tempItems = response.response.data.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      )
      var cleanedArray = tempItems.map((item) => {
        var info = {}

        info.name = "item_id"
        info.label = `${item.name}-${item.item_units[0]?.unit_to}`
        info.value = `${item.id}`

        return info
      })
      setItemNames(cleanedArray)
    }
  }

  async function fetchBranches() {
    const response = await getAllBranches()

    setBranches([])

    if (response.data) {
      var data = response.data.data
      data.map((d) => {
        var info = {}
        info.label = d.name
        info.value = d.id
        info.name = "branch_id"
        info.type = ""
        setBranches((prev) => [...prev, info])
      })
    }
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  async function fetchOrderDetail(data) {
    setSelectedRow([])
    handleShowViewModal()

    const response = await searchOrder({
      order_id: data.doc_id,
      date_from: data.doc_date,
      date_to: data.doc_date,
    })

    if (response.error) {
      setSelectedRow([])
    } else {
      var allBills = response.data.data.map((bill, index) => {
        var paytype = bill.payment[0]?.payment_type.split("_")
        var info = bill
        info.amount = numberFormat(bill.subtotal)
        info.transaction_type = bill.transaction_type
        info.qty = bill.order_detail
          ?.map((item) => item.qty)
          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
        info.amount = bill.order_detail
          ?.map((item) => item.subtotal)
          .reduce((a, b) => parseInt(a) + parseInt(b), 0)

        info.subtotal = bill.payment[0]?.subtotal
        info.active_discount = numberFormat(
          parseFloat(bill.payment[0]?.discount) +
            parseFloat(bill.payment[0]?.merchant_discount_share)
        )
        info.total_discount = numberFormat(
          parseFloat(bill.payment[0]?.discount) +
            parseFloat(bill.payment[0]?.merchant_discount_share) +
            parseFloat(bill.payment[0]?.additional_discounts)
        )
        info.discount = numberFormat(bill.payment[0]?.discount)
        info.merchant_discount_share = numberFormat(
          bill.payment[0]?.merchant_discount_share
        )
        info.additional_discounts = numberFormat(
          bill.payment[0]?.additional_discounts
        )
        info.computed_grand_total = numberFormat(
          parseFloat(bill.grand_total) -
            parseFloat(bill.discount) +
            parseFloat(bill.payment[0]?.delivery_fee)
        )
        info.delivery_fee = numberFormat(bill.payment[0]?.delivery_fee)
        info.grand_total = numberFormat(bill.grand_total)
        info.paid_amount = numberFormat(bill.paid_amount)
        info.payment_type =
          paytype.length < 2
            ? bill.payment[0]?.payment_type
            : paytype[0] + " " + paytype[1]
        info.pay_ref_no = bill.payment[0]?.reference_no
        info.pay_ref_no_export = '=""' + bill.payment[0]?.reference_no + '""'
        info.tran_ref_no = bill.payment[0]?.transaction_no
          ? bill.payment[0]?.transaction_no
          : bill.payment[0]?.reference_no
          ? bill.payment[0]?.reference_no
          : ""
        info.tran_ref_no_export = bill.payment[0]?.transaction_no
          ? '=""' + bill.payment[0]?.transaction_no + '""'
          : bill.payment[0]?.reference_no
          ? '=""' + bill.payment[0]?.reference_no + '""'
          : ""
        info.time = new Date(bill.added_on).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
        return info
      })
      setSelectedRow(allBills[0])
    }
  }

  async function searchHistoryFilter() {
    setShowLoader(true)
    setExcelData([])
    setItemList([])
    const response = await searchHistory(filterConfig)
    if (response.error) {
      setShowLoader(false)
    } else if (response.data) {
      var history = response.data?.history
      setBranchName(response.data?.inventory?.branch_name)
      setItemUnit(response.data?.inventory?.unit)
      setItemNamesValue({
        name: "item_id",
        label: response.data?.inventory?.item_name,
        value: response.data?.inventory?.item_id,
      })
      setBranchValue({
        name: "branch",
        label: response.data.inventory?.branch_name,
        value: response.data.inventory?.branch_id,
      })

      history?.map((PO) => {
        var info = PO

        info.date = PO.doc_date
          ? Moment(PO.doc_date).format("MMM DD, YYYY")
          : Moment(PO.encoded_on).format("MMM DD, YYYY")
        info.encoded_on = PO.encoded_on
          ? Moment(PO.encoded_on).format("MMM DD, YYYY")
          : ""
        info.transfer_date = PO.transfer_date
          ? Moment(PO.transfer_date).format("MMM DD, YYYY")
          : ""
        info.receive_date = PO.receive_date
          ? Moment(PO.receive_date).format("MMM DD, YYYY")
          : ""
        info.doc_type = PO.doc_type
        // info.doc_type = PO.doc_type === "Transfer" ? "Transfer Out" : PO.doc_type === "Transfer Receive" ? "Transfer In" : PO.doc_type;
        info.doc_no = PO.doc_no ? PO.doc_no : ""
        info.doc_id = PO.doc_id
        info.slip_no = PO.slip_no
          ? PO.slip_no
          : PO.doc_type === "Transfer Out"
          ? PO.doc_no + " - " + PO.doc_id
          : PO.doc_no
        info.added_by_name = PO.added_by_name
        info.supplier = PO.supplier_name
        info.branch = PO.branch_name
        info.in =
          PO.qty_in !== null ? parseFloat(PO?.qty_in).toFixed(2) : "0.00"

        info.out =
          PO.qty_out !== null ? parseFloat(PO?.qty_out).toFixed(2) : "0.00"

        info.current_qty =
          PO.current_qty !== null
            ? parseFloat(PO?.current_qty).toFixed(2)
            : "0.00"
        info.in = numberWithCommas(info.in)
        info.out = numberWithCommas(info.out)
        info.current_qty = numberWithCommas(info.current_qty)

        setItemList((prev) => [...prev, info])
      })

      history?.map((PO) => {
        var info = {}

        info.date = PO.doc_date
          ? Moment(PO.doc_date).format("MMM DD, YYYY")
          : Moment(PO.encoded_on).format("MMM DD, YYYY")
        info.doc_type = PO.doc_type
        info.slip_no = PO.slip_no
          ? PO.slip_no
          : PO.doc_type === "Transfer Out"
          ? PO.doc_no + " - " + PO.doc_id
          : PO.doc_no
        info.in = PO.qty_in !== null ? numberFormat(PO?.qty_in) : "0.00"
        info.out = PO.qty_out !== null ? numberFormat(PO?.qty_out) : "0.00"
        info.current_qty = PO.current_qty
        info.branch_from_name = PO.branch_from_name
        info.branch_to_name = PO.branch_to_name
        info.encoded_on = PO.encoded_on
          ? Moment(PO.encoded_on).format("MMM DD, YYYY")
          : ""
        info.transfer_date = PO.transfer_date
          ? Moment(PO.transfer_date).format("MMM DD, YYYY")
          : ""
        info.receive_date = PO.receive_date
          ? Moment(PO.receive_date).format("MMM DD, YYYY")
          : ""
        info.added_by_name = PO.added_by_name

        setExcelData((prev) => [...prev, info])
      })
    }
    setShowLoader(false)
  }

  function DocBtn(row) {
    return (
      <span
        className="me-4 align-middle ps-label blue"
        onClick={() => handleViewDoc(row.doc_id, row.doc_type, source_api, row)}
      >
        {row.slip_no}
      </span>
    )
  }
  function handleViewDoc(id, type, api, row) {
    if (type === "Adjustment") {
      window.open("/adjustments/view/" + id)
    } else if (type === "Transfer Out" || type === "Transfer In") {
      window.open(
        "/transfers/view/" +
          api.split("_")[0].replace(/\b[a-z]/g, (x) => x.toUpperCase()) +
          "-" +
          id +
          "/" +
          "completed"
      )
    } else if (type === "Franchisee Sale") {
      window.open("/salesinvoice/print/" + id)
    } else if (type === "Build Item") {
      window.open("/buildItem/" + id)
    } else if (type === "Purchase Invoice") {
      window.open("/purchaseinvoices/print/" + id)
    } else if (type === "Order") {
      fetchOrderDetail(row)
    }
  }

  function handleExport() {
    const rows = excelData.slice().reverse()

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(
      workbook,
      `ItemHistory (${itemNamesValue.label} - ${Moment(
        filterConfig.date_from
      ).format("MMM DD, YYYY")} - ${Moment(filterConfig.date_to).format(
        "MMM DD, YYYY"
      )}).xlsx`,
      { compression: true }
    )
  }

  useEffect(() => {
    // fetchHistory();
    fetchAllItems()
    fetchBranches()
  }, [])

  useEffect(() => {
    setItemList([])
    searchHistoryFilter()
  }, [isChanged, filterConfig])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WH INVENTORY"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              ITEM HISTORY{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={5}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              placeholder="Search doc no..."
              className="search-bar"
              name="doc_no"
              defaultValue=""
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleAddChange(e)
              }
            ></input>
          </Col>
          <Col
            xs={12}
            lg={1}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3 mt-3 mt-lg-0"
          >
            <h3 className="page-subtitle mb-0 mt-1">
              {" "}
              <strong>Item:</strong>
            </h3>
          </Col>
          <Col xs={12} lg={4}>
            <Select
              className="react-select-container z-index-large"
              classNamePrefix="react-select"
              placeholder="Select item..."
              options={itemNames}
              onChange={(e) => handleAddChange(e, "item")}
              value={itemNames.find(
                (item) => item.value === itemNamesValue.value
              )}
            />
          </Col>
          <Col xs={12} lg={2} className="mt-3 mt-lg-0">
            <h3 className="page-subtitle text-capitalize mb-0 mt-1">
              {" "}
              <strong>Unit:</strong> {itemUnit}{" "}
            </h3>
          </Col>
          <Col
            xs={12}
            lg={1}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3 mt-3 mt-lg-0"
          >
            <h3 className="page-subtitle mb-0 mt-1">
              {" "}
              <strong>Branch:</strong>
            </h3>
          </Col>
          <Col xs={12} lg={4}>
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Select item..."
              value={branches.find(
                (branch) => branch.value === filterConfig.branch_id
              )}
              options={branches}
              // onChange={(e) => setFilterConfig((prev) => ({...prev, item_id: e.value}))}
              onChange={(e) => handleAddChange(e, "branch")}
            />
          </Col>
        </Row>

        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={8} className="mb-2 mb-lg-0">
              <Form.Select
                name="doc_type"
                className="date-filter me-2"
                onChange={(e) => handleAddChange(e)}
              >
                <option value="" selected>
                  {" "}
                  All Doc Types{" "}
                </option>
                {/* <option value="Transfer Out"> Transfer Out</option> */}
                <option value="Adjustment"> Adjustment </option>
                {/* <option value="Build Item" > Build Item </option> */}
                {/* <option value="order" > Order </option> */}
                <option value="Purchase Invoice"> Purchase Invoice </option>
                <option value="Purchase Return"> Purchase Return </option>
                <option value="Purchase Replacement">
                  {" "}
                  Purchase Replacement{" "}
                </option>
                <option value="Sales Invoice"> Sales Invoice </option>
                {/* <option value="Transfer In" > Transfer In </option> */}
                {/* <option value="Transfer Out" > Transfer Out</option> */}
              </Form.Select>
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.date_from}
                placeholderText={"Select Date From"}
                name="date_from"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return { ...prev, date_from: date }
                  })
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.date_to}
                placeholderText={"Select Date To"}
                name="date_to"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return { ...prev, date_to: date }
                  })
                }}
                minDate={filterConfig.date_from}
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
          </Row>
          <div className="mb-3" />

          <Table
            tableType={"item_history"}
            tableHeaders={[
              "DOC DATE",
              "DOC TYPE",
              "DOC NO.",
              "IN",
              "OUT",
              "CURRENT",
              // "REQUESTED BY",
              // "APPROVED BY",
              "ENCODED ON",
              "ENCODED BY",
            ]}
            headerSelector={[
              "date",
              "doc_type",
              "slip_no",
              "in",
              "out",
              "current_qty",
              // "requested_by_name",
              // "approved_by_name",
              "encoded_on",
              "added_by_name",
            ]}
            tableData={itemList.slice().reverse()}
            ContractBtn={(row) => DocBtn(row)}
            showLoader={showLoader}
          />
          <div className="mb-2" />
        </div>
        <Row className="mb-4 mt-3">
          <Col lg={8}></Col>
          <Col lg={2} className="mt-3 mt-lg-2">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
          <Col lg={2} className="mt-3 mt-lg-2">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={() => navigate("/itemlists")}
              >
                Back
              </button>
            </div>
          </Col>
        </Row>
        <br />
        <br />
        <br />
      </div>

      <ViewModal
        withCloseButtons
        show={showViewModal}
        onHide={handleCloseViewModal}
      >
        <div className="mt-0">
          <div className="col-sm-12 m-0 space">
            <Row className="custom-modal-body-title-daily-orders w-100">
              <Col xs={3} className="custom-modal-pic-right">
                <img width={50} height={50} src={Smoothie} alt=""></img>
              </Col>
              <Col xs={6}>
                <Row className="justify-content-center">
                  Order {selectedRow.id}
                </Row>
                <Row className="custom-modal-sub-daily-orders ">
                  {selectedRow.time}
                </Row>
              </Col>
              <Col xs={3} className="custom-modal-pic-left">
                <img width={50} height={50} src={Smoothie} alt=""></img>
              </Col>
            </Row>
            <Row className="custom-modal-body-title-branch-details-no-pic w-100">
              <Col xs={12} className="justify-content-center">
                {branchName}
              </Col>
            </Row>
            {/* <span className="custom-modal-body-title-branch-details-no-pic">
                            {branchName}
                        </span> */}
            <div className="mt-3 ">
              <Row className="nc-modal-custom-row-view">
                <Col xl={9}>
                  <Col className="ms-3">
                    {selectedRow?.order_detail?.length > 0
                      ? selectedRow.order_detail.map((data) => {
                          return (
                            <>
                              <Row>
                                {" "}
                                {data.product_name.split("-")[0] +
                                  " - " +
                                  data.product_name.split("-")[1]}{" "}
                              </Row>
                              <Row className="custom-modal-sub-product">
                                PHP {numberFormat(data.price)}
                              </Row>
                              {data.product_detail.length > 0
                                ? data.product_detail.map((prod) => {
                                    return (
                                      <>
                                        <Row className="custom-modal-sub-product">
                                          {"x" +
                                            prod.qty +
                                            " " +
                                            prod.product_name +
                                            " = P" +
                                            prod.price}
                                        </Row>
                                      </>
                                    )
                                  })
                                : ""}
                            </>
                          )
                        })
                      : ""}
                  </Col>
                </Col>
                <Col xl={3}>
                  <Col className="nc-modal-custom-row">
                    {selectedRow?.order_detail?.length > 0
                      ? selectedRow.order_detail.map((data) => {
                          return (
                            <>
                              <Row className="custom-modal-sub-product-yellow justify-content-center">
                                {" "}
                                {data.qty}{" "}
                              </Row>
                              <Row className="justify-content-center">
                                PHP {numberFormat(data.priceWithAddOn)}
                              </Row>
                              {data.product_detail.length > 0
                                ? data.product_detail.map((prod) => {
                                    return (
                                      <>
                                        <Row className="custom-modal-sub-product-white">
                                          {"-"}
                                        </Row>
                                      </>
                                    )
                                  })
                                : ""}
                            </>
                          )
                        })
                      : ""}
                  </Col>
                </Col>
              </Row>
            </div>
            <br />
            <div className="break"> </div>
            <div className="mt-3 ">
              <Row className="nc-modal-custom-row-view">
                {selectedRow?.payment
                  ? selectedRow?.payment[0]?.discounts?.length > 0 && (
                      <>
                        <Row className="ms-1 me-1">Discount Details</Row>
                        {selectedRow.payment
                          ? selectedRow?.payment[0]?.discounts?.length > 0
                            ? selectedRow?.payment[0]?.discounts.map((data) => {
                                return (
                                  <>
                                    <Row className="ms-1 me-1">
                                      <Col xs={6} className="">
                                        <Row className="custom-modal-sub-product">
                                          {" "}
                                          {data.name}{" "}
                                        </Row>
                                      </Col>
                                      <Col xs={6} className="">
                                        <Row className="custom-modal-sub-product justify-content-end">
                                          {" "}
                                          {data.id_no || "N/A"}{" "}
                                        </Row>
                                      </Col>
                                    </Row>
                                  </>
                                )
                              })
                            : ""
                          : ""}
                      </>
                    )
                  : ""}
                <Col xl={12}>
                  <Row className="ms-1 me-1">
                    <Col xs={6} className="">
                      <Row> Transaction Method </Row>
                      <Row className="custom-modal-sub-product">
                        {" "}
                        Reference No.{" "}
                      </Row>
                    </Col>
                    <Col xs={6} className="">
                      <Row className="justify-content-end">
                        {" "}
                        {selectedRow?.transaction_type}{" "}
                      </Row>
                      <Row className="custom-modal-sub-product justify-content-end">
                        {" "}
                        {selectedRow?.tran_ref_no || "N/A"}{" "}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="ms-1 me-1">
                    <Col xs={6} className="">
                      <Row> Payment Method </Row>
                      <Row className="custom-modal-sub-product">
                        {" "}
                        Reference No.{" "}
                      </Row>
                    </Col>
                    <Col xs={6} className="">
                      <Row className="justify-content-end">
                        {" "}
                        {selectedRow?.payment_type}{" "}
                      </Row>
                      <Row className="custom-modal-sub-product justify-content-end">
                        {" "}
                        {selectedRow?.pay_ref_no || "N/A"}{" "}
                      </Row>
                    </Col>
                  </Row>
                  <div className="break"> </div>
                  <Row className="ms-1 me-1">
                    <Col xs={6} className="">
                      <Row className="bolder system-total"> System Total </Row>
                      <Row> Delivery Fee </Row>
                      <hr />
                      <Row> Active Discount </Row>
                      <Row className="custom-modal-sub-product ms-3">
                        {" "}
                        Discount(MM){" "}
                      </Row>
                      <Row className="custom-modal-sub-product ms-3">
                        {" "}
                        Discount(Merchant){" "}
                      </Row>
                      <Row> Additional Discount </Row>
                      <Row className="custom-modal-sub-product ms-3">
                        {" "}
                        Discount Code{" "}
                      </Row>
                      <Row> Total Discount </Row>
                      <hr />
                      <Row className="bolder system-total"> Grand Total </Row>
                    </Col>
                    <Col xs={6} className="">
                      {/* <Row className="justify-content-end"> PHP {selectedRow?.subtotal} </Row> */}
                      <Row className="justify-content-end bolder system-total">
                        {" "}
                        PHP {selectedRow?.subtotal}{" "}
                      </Row>
                      <Row className="justify-content-end">
                        + PHP {selectedRow?.delivery_fee}{" "}
                      </Row>
                      <hr />
                      <Row className="justify-content-end">
                        {selectedRow?.discount_description +
                          " - " +
                          selectedRow?.active_discount}{" "}
                      </Row>
                      <Row className="justify-content-end custom-modal-sub-product">
                        PHP {selectedRow?.discount}{" "}
                      </Row>
                      <Row className="justify-content-end custom-modal-sub-product">
                        PHP {selectedRow?.merchant_discount_share}{" "}
                      </Row>
                      <Row className="justify-content-end">
                        - PHP {selectedRow?.additional_discounts}{" "}
                      </Row>
                      <Row className="justify-content-end custom-modal-sub-product">
                        {" "}
                        {selectedRow?.discount_code !== ""
                          ? selectedRow?.discount_code
                          : "N/A"}{" "}
                      </Row>
                      <Row className="justify-content-end">
                        - PHP {selectedRow?.total_discount}{" "}
                      </Row>
                      <hr />
                      <Row className="justify-content-end bolder system-total">
                        {" "}
                        PHP {selectedRow?.paid_amount}{" "}
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>
      <Footer />
    </div>
  )
}
